import {IconFileDescription, IconFolder} from '@tabler/icons-react';
import type {ReactNode} from 'react';
import type {TreeResponse} from 'src/api/ProactApiClient';
import {TreeResponseBrowser} from 'src/app/tree-browser/TreeResponseBrowser';
import {useGetDocumentTreeQuery} from 'src/redux/queries/document';
import {documentTreeRootId} from './documentTreeBrowserState';

const documentFolderIcon = (
  <IconFolder size={16} color="var(--mantine-color-blue-6)" />
);
const documentFileIcon = <IconFileDescription size={16} />;
const documentIconsByKind = {
  folder: documentFolderIcon,
  file: documentFileIcon,
};

export interface DocumentTreeBrowserProps {
  selectedId?: string;
  onSelect: (id: string, node?: TreeResponse) => void;
  children: ReactNode;
}

/** Document folder/file query adapter for the shared tree-response browser. */
export const DocumentTreeBrowser = ({
  selectedId,
  onSelect,
  children,
}: DocumentTreeBrowserProps) => {
  const query = useGetDocumentTreeQuery({});

  return (
    <TreeResponseBrowser
      query={query}
      rootId={documentTreeRootId}
      rootLabel="All Documents"
      paneTitle="Documents"
      expansionKey="documents"
      selectedId={selectedId}
      onSelect={onSelect}
      icon={documentFolderIcon}
      iconsByKind={documentIconsByKind}
      searchPlaceholder="Search documents"
      emptyText="No documents found."
      unavailableItemName="document"
      unavailableLabel="Unavailable document"
      resetLabel="Show All Documents">
      {children}
    </TreeResponseBrowser>
  );
};
